import { render } from "./TargetCard.vue?vue&type=template&id=8031f6fa&scoped=true"
import script from "./TargetCard.vue?vue&type=script&lang=js"
export * from "./TargetCard.vue?vue&type=script&lang=js"

import "./TargetCard.vue?vue&type=style&index=0&id=8031f6fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8031f6fa"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QTooltip,QCardSection,QIcon,QCheckbox,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QSelect,QChip,QInput,QBtn,QPopupProxy,QDate,QSeparator,QMenu,QCardActions,QSpace,QSlideTransition});qInstall(script, 'directives', {ClosePopup,Ripple});
